/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { Fragment, useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { commonIcon } from "../../asset/index";
import { mixingAudio } from "../../store/chat-action";
import { uiAction } from "../../store/ui-gemini";
import styles from "./CopyBtn.module.css";
import { IconSpinner } from "./Icon";

const MixingAudio = ({ messageId, isPlaying, onPlaying }) => {
  const [loading, setLoading] = useState(false);
  const [playing, setPlay] = useState(false);
  const [currentTrack, setCurrentTrack] = useState(null);
  const refAudio = useRef();
  const currentPlaySound = useSelector((state) => state.ui.currentPlaySound);

  const dispatch = useDispatch();

  useEffect(() => {
    if (currentTrack && refAudio && refAudio.current) {
      refAudio.current.play();
      setPlay(true);
      refAudio.current.addEventListener("ended", () => {
        setCurrentTrack(null);
        setPlay(false);
        return;
      });
    }
  }, [currentTrack, refAudio]);

  useEffect(() => {
    if (playing) {
      dispatch(uiAction.setCurrentPlaySound(`vip_${messageId}`));
    }
  }, [playing]);

  useEffect(() => {
    if (currentPlaySound !== `vip_${messageId}`) {
      if (playing && currentTrack && refAudio && refAudio.current) {
        stop();
      }
    }
  }, [currentPlaySound]);

  const stop = () => {
    refAudio.current.pause();
    setPlay(false);
    setCurrentTrack(null);
  };

  const playAudio = async () => {
    setLoading(true);
    const callAPI = async () => {
      try {
        await mixingAudio(messageId);
        const audio = `${process.env.REACT_APP_MEDIA_BASE_URL}/storage/audio/custom/${messageId}/mixed_output.mp3`;

        setCurrentTrack(audio);
        setLoading(false);
      } catch (err) {
        console.error(err);
        setLoading(false);
        if (err && err.response.status && err.response.status === 429) {
          dispatch(uiAction.toggleCustomVoiceAddon());
        }
        // Handle error appropriately, e.g., display an error message to the user
      }
    };
    callAPI();
  };

  return (
    <Fragment>
      {currentTrack && (
        <audio
          className={`${playing ? "visible" : "invisible"} w-60 md:w-96`}
          // controls
          ref={refAudio}
          src={currentTrack}
          type="audio/mpeg"
        >
          Your browser does not support the audio element.
        </audio>
      )}

      <div
        className={`${styles["copy-icon"]} ${styles["mixed-audio"]} flex justify-center items-center gap-1`}
      >
        {loading ? (
          <IconSpinner className="cursor-pointer size-5" />
        ) : (
          <>
            {playing ? (
              <button>
                <img
                  src={commonIcon.goldNoSound}
                  alt="Custom Sound"
                  onClick={stop}
                  className="cursor-pointer !size-6"
                />
              </button>
            ) : (
              <button onClick={(e) => playAudio()}>
                <img
                  src={commonIcon.mixingAudioIcon}
                  alt="Custom Sound"
                  className="cursor-pointer !size-6"
                />
              </button>
            )}
          </>
        )}
      </div>
    </Fragment>
  );
};

export default MixingAudio;
